const manpowerRecruitment = [
  {
    path: '/manpower',
    name: 'Manpower',
    component: () => import('@/views/wxapp/manpower-recruitment/index.vue'),
    meta: {
      title: '招聘日更'
    },
    children: [
      {
        path: 'manpower-recruitment',
        name: 'ManpowerRecruitment',
        component: () => import('@/views/wxapp/manpower-recruitment/recruitment-information/index.vue'),
        meta: {
          title: '招聘日更'
        }
      }
    ]
  }
]
export default manpowerRecruitment
